import { FC } from "react";

import { Card } from "react-bootstrap";

import { Check } from "lucide-react";

import { Customer } from "@/_services/invoiceService";

import { useProductManagementContext } from "../hooks/useProductManagementContext";
import { useQuoteAssociation } from "../hooks/useQuoteAssociation";

interface Props {
  selectedCustomer: string;
  customers: Customer[];
  filteredCustomers: Customer[];
  selectedCustomerData?: Customer | null;
}

const OrderSummaryCard: FC<Props> = ({
  selectedCustomer,
  customers,
  filteredCustomers,
  selectedCustomerData,
}) => {
  const { quoteOption, selectedQuote } = useQuoteAssociation();
  const { getSelectedProductsCount, calculateTotal } = useProductManagementContext();
  return (
    <Card className="border-0 shadow-sm bg-white">
      <Card.Header>
        <Card.Title className="flex items-center space-x-2">
          <Check className="w-4 h-4 text-purple-600" />
          <span className="text-sm">Récapitulatif</span>
        </Card.Title>
      </Card.Header>
      <Card.Body>
        <div className="space-y-3 text-sm">
          <div className="flex justify-between">
            <span className="text-gray-600">Commande:</span>
            <span className="font-medium">CMD-2025-0156</span>
          </div>
          <div className="flex justify-between">
            <span className="text-gray-600">Action devis:</span>
            <span className="font-medium">
              {quoteOption === "existing"
                ? "Association existant"
                : "Création nouveau"}
            </span>
          </div>
          {quoteOption === "existing" && selectedQuote && (
            <div className="flex justify-between">
              <span className="text-gray-600">Devis sélectionné:</span>
              <span className="font-medium">{selectedQuote}</span>
            </div>
          )}
          {quoteOption === "new" && getSelectedProductsCount() > 0 && (
            <>
              <div className="flex justify-between">
                <span className="text-gray-600">Produits sélectionnés:</span>
                <span className="font-medium">{getSelectedProductsCount()}</span>
              </div>
              <div className="flex justify-between">
                <span className="text-gray-600">Montant total:</span>
                <span className="font-medium text-purple-600">
                  {calculateTotal().toLocaleString("fr-FR")} €
                </span>
              </div>
            </>
          )}
          {selectedCustomer && (
            <div className="flex justify-between">
              <span className="text-gray-600">Client:</span>
              <span className="font-medium">
                {selectedCustomerData?.name ||
                  customers.find((c) => c.id.toString() === selectedCustomer)?.name ||
                  filteredCustomers.find((c) => c.id.toString() === selectedCustomer)?.name}
              </span>
            </div>
          )}
        </div>
      </Card.Body>
    </Card>
  );
};

export default OrderSummaryCard;
